import Search from "@mui/icons-material/Search";
import { TextField } from "@mui/material";
import { useCallback, useRef } from "react";

import type { TextFieldProps } from "@mui/material";
import type { FC, SubmitEventHandler } from "react";

export type SearchFieldProps = Omit<TextFieldProps, "onSubmit" | "value"> & {
  onSubmit?: (value: string) => void;
  defaultValue: string;
};

export const SearchField: FC<SearchFieldProps> = ({
  label,
  title,
  onChange,
  onSubmit,
  defaultValue,
  slotProps,
  ...textFieldProps
}) => {
  const formRef = useRef<HTMLFormElement>(null);
  const ref = useRef<HTMLInputElement>(null);

  const handleSubmit: SubmitEventHandler<HTMLFormElement> = useCallback(
    (e) => {
      e.preventDefault();
      onSubmit?.(ref.current?.value ?? "");
    },
    [onSubmit, ref],
  );

  const endAdornment = (
    <Search
      fontSize="small"
      sx={{ ml: 1.5, cursor: onSubmit ? "pointer" : "initial" }}
      onClick={() => onSubmit?.(ref.current?.value ?? "")}
    />
  );

  return (
    <form onSubmit={handleSubmit} ref={formRef}>
      <TextField
        inputRef={ref}
        name="search"
        label={label ?? "Search"}
        title={title ?? "Search"}
        fullWidth
        slotProps={{
          ...slotProps,
          // The caller's input props, as an object or worked out from the owner state, with the icon.
          input: (ownerState) => ({
            ...(typeof slotProps?.input === "function"
              ? slotProps.input(ownerState)
              : slotProps?.input),
            endAdornment,
          }),
        }}
        onChange={onChange}
        defaultValue={defaultValue}
        {...textFieldProps}
      />
    </form>
  );
};
